<template>
<div>
    <div v-if="ie=='i'">
        <!-- 肯尼亚(KEN)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">提单号</th>
                        <td width="25%">{{billInfo.BillOfLadingNumber}}</td>
                        <th width="25%">进口商ID</th>
                        <td width="25%">{{billInfo.ImporterId}}</td>
                    </tr>
                    <tr>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                        <th>包装类型</th>
                        <td>{{billInfo.PackageType}}</td>
                    </tr>
                    <tr>
                        <th>肯尼亚海关金额</th>
                        <td>{{billInfo.TotalKesValue}}</td>
                        <th>肯尼亚海关金额单位</th>
                        <td>{{billInfo.TotalKesValueUnit}}</td>
                    </tr>
                    <tr>
                        <th>海关金额</th>
                        <td>{{billInfo.TotalUSD}}</td>
                        <th>海关金额单位</th>
                        <td>{{billInfo.TotalUSDUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">来源国</th>
                        <td width="25%">{{billInfo.CountryStd}}</td>
                        <th width="25%">运输方式</th>
                        <td width="25%">{{billInfo.Transport}}</td>
                    </tr>
                    <tr>
                        <th>目的区</th>
                        <td>{{billInfo.EntryPort}}</td>
                        <th>目的港</th>
                        <td>{{billInfo.DischargePort}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">代理商信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">代理商</th>
                        <td width="25%">{{billInfo.AgentName}}</td>
                        <th width="25%">代理ID</th>
                        <td width="25%">{{billInfo.AgentID}}</td>
                    </tr>
                    <tr>
                        <th>代理商地址</th>
                        <td colspan="3">{{billInfo.AgentAddress}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 肯尼亚(KEN)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">提单号</th>
                        <td width="25%">{{billInfo.BillOfLadingNumber}}</td>
                        <th width="25%">出口商ID</th>
                        <td width="25%">{{billInfo.ExporterId}}</td>
                    </tr>
                    <tr>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                        <th>包装类型</th>
                        <td>{{billInfo.PackageType}}</td>
                    </tr>
                    <tr>
                        <th>肯尼亚海关金额</th>
                        <td>{{billInfo.TotalKesValue}}</td>
                        <th>肯尼亚海关金额单位</th>
                        <td>{{billInfo.TotalKesValueUnit}}</td>
                    </tr>
                    <tr>
                        <th>海关金额</th>
                        <td>{{billInfo.TotalUSD}}</td>
                        <th>海关金额单位</th>
                        <td>{{billInfo.TotalUSDUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>